import {WhatsApp} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {getElection} from '../../../features/election/store/selectors';
import './button.css';

const ButtonWhatsApp: React.FC = () => {
  const election = useSelector(getElection);
  const [whatsappNumber, setWhats] = useState<string | null>(null);

  useEffect(() => {
    let phoneNumber =
      election && election.configs && election.configs.whatsapp
        ? election.configs.whatsapp
        : '';

    phoneNumber = clearPhoneNumber(phoneNumber);

    if (phoneNumber.length > 11) {
      setWhats(phoneNumber);
    }
  }, [election]);

  const clearPhoneNumber = (phoneNumber: string) => {
    return phoneNumber
      ? phoneNumber.replace(/[\/\s&\/\\#,+()$~%.'":*?<>{}\/-]/g, '')
      : '';
  };

  if (!whatsappNumber) {
    return null;
  }

  return (
    <a
      href={`https://wa.me/${whatsappNumber}`}
      target="_blank"
      className="button-whatsapp"
    >
      <WhatsApp fontSize="large" />
    </a>
  );
};

export default ButtonWhatsApp;



// WEBPACK FOOTER //
// ./src/shared/components/buttons/ButtonWhatsApp.tsx